/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface CRAAggregationFindingAssets
 */
export interface CRAAggregationFindingAssets {
    /**
     * 
     * @type {string}
     * @memberof CRAAggregationFindingAssets
     */
    asset: string;
    /**
     * 
     * @type {Port}
     * @memberof CRAAggregationFindingAssets
     */
    port: Port;
    /**
     * 
     * @type {string}
     * @memberof CRAAggregationFindingAssets
     */
    source: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRAAggregationFindingAssets
     */
    shared: boolean;
    /**
     * 
     * @type {number}
     * @memberof CRAAggregationFindingAssets
     */
    found: number;
}

/**
 * Check if a given object implements the CRAAggregationFindingAssets interface.
 */
export function instanceOfCRAAggregationFindingAssets(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "found" in value;

    return isInstance;
}

export function CRAAggregationFindingAssetsFromJSON(json: any): CRAAggregationFindingAssets {
    return CRAAggregationFindingAssetsFromJSONTyped(json, false);
}

export function CRAAggregationFindingAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRAAggregationFindingAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'port': PortFromJSON(json['port']),
        'source': json['source'],
        'shared': json['shared'],
        'found': json['found'],
    };
}

export function CRAAggregationFindingAssetsToJSON(value?: CRAAggregationFindingAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'port': PortToJSON(value.port),
        'source': value.source,
        'shared': value.shared,
        'found': value.found,
    };
}

